/**
 * Renderiza o template substituindo as variáveis.
 *
 * @param {string} template
 * @param {object} vars
 */
export function render(template, vars) {
    Object.keys(vars).forEach(name => {
        template = template.replace(new RegExp('%' + name + '%', 'g'), vars[name])
    })

    return template
}
